import VueAxios from "vue-axios";

import axios from "./service.js";

/**
 * The panel's HTTP client, in the two places the code reaches for it:
 * - this.axios / this.$http on every component (vue-axios);
 * - window.$http.axios in the store modules. Under Vue 2, window.$http was the
 *   Vue constructor that vue-axios had hung .axios on, and .axios is the only
 *   property of it that was ever used.
 */
export default function installHttp(app) {
  app.use(VueAxios, axios);
  window.$http = { axios };
}
